import { useApi } from '@/api';
import {
  ActivityCard,
  EntityName,
  ExternalLinkIcon,
  KpiCard,
  Link,
  LinkButton,
  Page,
  PageSkeleton
} from '@/components';
import {
  ArrowRightIcon,
  Card,
  CryptoIcon,
  Flex,
  Heading,
  LinkWrapper
} from '@blockanalitica/ui';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import HistoricTabs from './HistoricTabs';

export default function SparkIlkPage() {
  const { ilk } = useParams();
  const [data, error] = useApi({
    url: `/groups/spark/ilks/${ilk}/`,
    queryParams: {
      days_ago: 1
    }
  });

  const Arrow = styled(ArrowRightIcon)`
    align-self: flex-end;
    color: ${(props) => props.theme.colors.muted};
  `;

  if (error) {
    throw error;
  }
  const [protocol, link] = useMemo(() => {
    switch (ilk) {
      case 'DIRECT-SPARK-DAI':
        return ['Spark', 'spark'];
      case 'DIRECT-SPARK-MORPHO-DAI':
        return ['Morpho', 'morpho'];
      default:
        return [null, null];
    }
  }, [ilk]);

  if (data) {
    return (
      <Page
        title={
          <EntityName
            symbol1={
              <CryptoIcon
                name={data.collateral_symbol}
                address={data.collateral_address}
                size="6"
              />
            }>
            <Flex gap="3xs" flexDirection="column">
              <Flex gap="3xs">
                <Heading size="1">{data.name}</Heading>
              </Flex>
              <Flex gap="3xs" color="muted">
                {data.ilk}
              </Flex>
            </Flex>
          </EntityName>
        }
        actions={
          <>
            <LinkButton
              to="https://data.spark.fi/spark-liquidity-layer"
              target="_blank">
              <Flex
                gap="3xs"
                alignItems="center"
                style={{ whiteSpace: 'nowrap' }}>
                SLL Dashboard
                <ExternalLinkIcon size="1" />
              </Flex>
            </LinkButton>
          </>
        }>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Debt"
            variant="dai"
            data={data}
            field="debt"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'DAI'
                }
              }
            }}
          />
          {protocol && (
            <LinkWrapper
              to={link}
              // @ts-ignore
              as={Link}
              variant="kpiCardLinkWithBlendMode">
              <Card flexDirection="row">
                <Flex
                  flexBasis="50%"
                  alignContent="center"
                  alignItems="center"
                  gap="3xs">
                  <CryptoIcon
                    name={data.collateral_symbol}
                    address={data.collateral_address}
                    size="6"
                  />
                  <Heading size="1"> {protocol}</Heading>
                </Flex>
                <Flex flexBasis="50%" justifyContent="flex-end">
                  <Arrow />
                </Flex>
              </Card>
            </LinkWrapper>
          )}
        </Flex>

        <HistoricTabs ilk={ilk} />

        <ActivityCard
          url={`/groups/spark/ilks/${ilk}/activity/`}
          linkTo="activity"
        />
      </Page>
    );
  }
  return <PageSkeleton />;
}
